export default __webpack_public_path__ + "479f9177abca729ad8dff43f79a395ca.png";